module.exports = __webpack_public_path__ + "img/hero-headshot.cb48edad.png";